// src/components/ui/atoms/Button/Button.tsx
import React, { CSSProperties } from 'react';

interface ButtonProps {
  onClick?(): void;
  children?: React.ReactNode;
  variant?:
    | 'default'
    | 'default-rounded'
    | 'outline'
    | 'plain'
    | 'black'
    | 'transparent'
    | 'outline-rounded'
    | 'outline-rounded-black'
    | 'underline'
    | 'remove'
    | 'header'
    | 'premium'
    | 'text-only';
  className?: string;
  disabled?: boolean;
  type?: 'button' | 'submit' | 'reset';
  form?: string;
  style?: CSSProperties;
}

export const Button = ({
  type = 'button',
  onClick,
  disabled,
  children,
  variant = 'default',
  className,
  form, // ← accept it
  style
}: ButtonProps) => {
  const classes: Record<string, string> = {
    underline:
      'text-sm text-primary mt-4 flex items-center gap-1 hover:underline',
    black:
      'w-full text-white text-sm py-3 px-6 rounded-full transition disabled:cursor-not-allowed',
    'outline-rounded':
      'rounded-full border border-black bg-gray-50 px-2 py-2 text-black hover:bg-gray-100 hover:shadow-[inset_0_0_0_1px_rgba(0,0,0,0.5)] disabled:opacity-50 disabled:cursor-not-allowed',
    'outline-rounded-black':
      'rounded-full border border-black bg-black px-2 py-2 text-white hover:bg-gray-100 hover:shadow-[inset_0_0_0_1px_rgba(0,0,0,0.5)] disabled:opacity-50 disabled:cursor-not-allowed',
    plain: 'text-black hover:underline',
    outline:
      'border text-sm border-gray-400 text-gray-600 px-4 rounded hover:bg-gray-100',
    premium:
    'mt-3 inline-flex items-center bg-purple-600 text-white font-medium py-2 px-4 rounded-md hover:bg-purple-700 transition',
    transparent:
      'w-full text-sm flex items-center justify-center gap-2 border border-gray-300 py-3 rounded-full hover:bg-gray-100 transition shadow-sm',
    default:
      'px-3 py-1 rounded-md font-medium border border-primary text-white bg-primary hover:bg-primary-dark transition flex items-center gap-2',
    'default-rounded':
      'px-3 py-1 rounded-full font-medium border border-primary text-white bg-primary hover:bg-primary-dark transition flex items-center gap-2',
    header:
      'fixed z-50 right-4 text-sm font-medium rounded-full border border-gray-600 bg-black text-white px-4 py-1.5 h-9 transition hover:bg-gray-700 disabled:opacity-40 disabled:cursor-not-allowed flex items-center',
    remove: 
      '',
    'text-only':
      'sticky rounded-full px-2 py-3 text-black hover:bg-gray-100 disabled:opacity-50 disabled:cursor-not-allowed',
  };

  if (variant === 'remove') {
    return (
      <button
        type="button"
        onClick={onClick}
        className="text-red-600 hover:text-red-800 text-lg leading-none"
      >
        ×
      </button>
    );
  }

  return (
    <button
      type={type}
      disabled={disabled}
      onClick={onClick}
      form={form}
      className={`${classes[variant]} ${className ?? ''}`}
      /* only for header, override top:0 with safe‐area */
      style={
        variant === 'header'
          ? { ...(style || {}), top: 'var(--safe-top)' }
          : style
      }
    >
      {children}
    </button>
  );
};
